/*

 */

import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {makeStyles} from "@material-ui/core";
import CancelButton from "../utilities/buttons/CancelButton";
import {CANCEL_ICON} from "../../constants/commonIcons";
import {DEPOSIT_INDICATOR_ICON_COLOR} from "../../constants/dataConstants";
import {adminActionSetGenericFullScreenDisplay} from "../../actions/adminActions";
import {fullScreenDisplaySelector} from "../../selectors/adminSelectors";
import {RESOURCE_TYPE_USER_WITHDRAW} from "../../constants/resourceConstants";
import AdminDisplayUserWithdraw from "./displays/adminDisplayUserWithdrawal";
import {UserWithdrawContainer} from "../../autoGenerated/components/containers/resourceContainers";
import {ADMIN_FULL_SCREEN_DISPLAY_MODE_DIALOG} from "../../constants/components/componentsConstants";

const useStyles = makeStyles(theme => ({
    dialogContent: {
        //padding: 0
    },
    xsScreenDialogContent: {
        padding: 0
    },
    titleText:{
        fontSize: 13,
        [theme.breakpoints.up("md")]: {
            fontSize: 15
        },
        [theme.breakpoints.up("lg")]: {
            fontSize: 17
        },
    }
}));

function AdminGenericFullScreenDialog({loading, error, deposit, ...props}) {
    const classes = useStyles();

    const dialogIsOpen = props.fullScreenDisplay.showDialog === true && props.fullScreenDisplay.displayMode === ADMIN_FULL_SCREEN_DISPLAY_MODE_DIALOG;

    if(dialogIsOpen !== true){
        return <React.Fragment/>;
    }

    return (
        <Dialog
            open={dialogIsOpen}
            onClose={handleClose}
            aria-labelledby="fullscreen-generic-dialog-title"
            fullWidth={true}
            maxWidth={'xl'}
            //fullScreen
        >
            <RenderDialogTitle/>

            <DialogContent>
                {renderDialogContent()}
            </DialogContent>

            <DialogActions>
                <CancelButton handleCloseFunction={handleClose} buttonText={'Close'}/>
            </DialogActions>
        </Dialog>
    );

    function renderDialogContent(){
        switch(props.fullScreenDisplay.resourceType){
            case RESOURCE_TYPE_USER_WITHDRAW:
                return (
                    <UserWithdrawContainer withdrawUID={props.fullScreenDisplay.resourceUID}>
                        <AdminDisplayUserWithdraw/>
                    </UserWithdrawContainer>
                );
        }
    }

    function RenderDialogTitle() {
        return (
            <DialogTitle id="fullscreen-generic-dialog-title">
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                >
                    <Grid item className={classes.titleText}>
                        Details
                    </Grid>

                    <Grid item>
                        <Tooltip
                            title={'Close'}
                            placement={'top'}
                        >
                            <IconButton
                                aria-label={'Close'}
                                onClick={handleClose}
                                size={'medium'}
                            >
                                <FontAwesomeIcon
                                    icon={CANCEL_ICON}
                                    color={DEPOSIT_INDICATOR_ICON_COLOR}
                                    fixedWidth
                                />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </DialogTitle>
        );
    }

    function handleClose() {
        props.adminActionSetGenericFullScreenDisplay({
            showDialog: false,
            resourceUID: props.fullScreenDisplay.resourceUID,
            resourceType: props.fullScreenDisplay.resourceType,
            displayMode: props.fullScreenDisplay.displayMode
        });
    }

}

const mapStateToProps = (state) => ({
    fullScreenDisplay: fullScreenDisplaySelector(state)
});

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators({
        adminActionSetGenericFullScreenDisplay: adminActionSetGenericFullScreenDisplay
    }, dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(AdminGenericFullScreenDialog);